<template>
  <div class="collectionSearch">
    <!-- top -->
    <div class="collectionNavTop" :style="navStyle">
      <div class="left">
        <button type="button" class="btnBack" @click="goBack">
          <img :src="btnBack.src" :style="btnBack.style" alt="" />
        </button>
      </div>
      <div class="searchBox">
        <input
          ref="searchCollection"
          type="text"
          placeholder="검색어를 입력해주세요."
          class="input"
          v-model="keyword"
          @keypress.enter="searchItemProperties" />
        <button type="button" class="btn btnWhite btnRound btnSearch" :style="btnStyle" @click.stop="searchItemProperties">검색</button>
      </div>
    </div>
    <!-- //top -->
    <!-- category -->
    <div class="collectionNavCategory"
      :style="categoryStyle">
      <div class="categoryWrap"
        :style="listStyle">
        <div class="categoryList" :style="categoryHeight">
          {{ list.length > 0 ? `"${resultKeyword}" 검색 결과` : '' }}
        </div>
      </div>
    </div>
    <!-- //category -->
    <div class="collectionContent searchResult" :style="pageStyle">
      <div class="contentPage listPage">
        <div v-if="list && list.length"
          class="collectionItemList"
          :style="listStyle">

<!-- <CollectionItem
  v-for="item in list"
  :key="item.collectionItemId"
  :locale="locale"
  :lang="lang"
  :item="item"
  :data-item="item.collectionItemId"
  :collectionIcon="collectionIcon"
  :itemDisplay="itemDisplay"
  @click.stop="setDetail(item)"
  @deleteItem="deleteItem" /> -->
<div
  v-for="item in list"
  :key="item.collectionItemId"
  class="item">
  <div class="img" @click.stop="setDetail(item)">
    <img :src="getItemThumb(item)" alt="">
    <!-- <button v-if="collectionIcon"
      type="button"
      class="btnCollection"
      @click.stop="deleteCollection(item.collectionItemId)">
      <img :src="collectionIcon.active" alt="" :style="{width: collectionIcon.size}">
    </button> -->
  </div>
  <div v-for="categoryId in item.categoryIds"
    :key="categoryId"
    class="itemCategory">
    <span @click.stop="goCategory(categoryId)">
      <span v-for="(name, index) in getCategoryNames(categoryId)"
        :key="index">
        {{ name }}
      </span>
    </span>
    <!-- {{ getCategoryName(categoryId) }} -->
  </div>
  <div class="text">
    <div class="left">
      <div class="name">
        {{ item.collectionItemName[lang] }}
      </div>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import CollectionItem from './MyCollectionItem'

export default {
  name: 'CollectionSearch',
  props: [
    'locale',
    'lang'
  ],
  components: {
    CollectionItem
  },
  computed: {
    getPageSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    getNavSetting () {
      return this.$store.getters['collection/getCollectionNavSetting']
    },
    getMyCollectionSetting () {
      return this.$store.getters['collection/getMyCollectionSetting']
    },
    listStyle () {
      const setting = this.getMyCollectionSetting
      return {
        gridTemplateColumns: `repeat(${setting.listColumn}, 1fr)`
      }
    },
    itemStyle () {
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return {
        ...spacing && spacing.name && {
          name: {
            letterSpacing: spacing.name
          }
        },
        ...spacing && spacing.descTop && {
          descTop: {
            letterSpacing: spacing.descTop
          }
        },
        ...spacing && spacing.descBottom && {
          descBottom: {
            letterSpacing: spacing.descBottom
          }
        }
      }
    },
    collectionIcon () {
      const myCollectionSetting = this.getMyCollectionSetting
      const scrapIcon = myCollectionSetting && {
        ...myCollectionSetting.scrapIcon,
        size: `${myCollectionSetting.scrapIcon.size}px`
      }
      return scrapIcon
    },
    itemDisplay () {
      const setting = this.getMyCollectionSetting
      return setting && setting.display
    },
    pageFrame () {
      return this.$store.getters['collection/getPageFrame']
    },
    categoryStyle () {
      const setting = this.getNavSetting
      const category = setting && setting.category
      const pageFrame = this.pageFrame
      const frame = pageFrame ? `${pageFrame}px` : ''
      return {
        backgroundColor: category && category.backgroundColor,
        ...frame && {
          paddingLeft: frame,
          paddingRight: frame
        }
      }
    },
    listStyle () {
      const setting = this.getNavSetting
      const category = setting && setting.category
      return {
        borderColor: category && category.borderColor,
      }
    },
    categoryHeight () {
      const setting = this.getNavSetting
      const category = setting && setting.category
      return {
        height: `${category && category.height}px`
      }
    },
    navStyle () {
      const setting = this.getNavSetting
      const navTop = setting && setting.navTop
      const pageFrame = this.pageFrame
      const frame = pageFrame ? `${pageFrame}px` : ''
      return setting && setting.category && {
        height: `${navTop && navTop.height}px`,
        ...frame && {
          paddingLeft: frame,
          paddingRight: frame
        }
      }
    },
    pageStyle () {
      const pageFrame = this.pageFrame
      const frame = pageFrame ? `${pageFrame}px` : ''
      return {
        ...frame && {
          padding: frame
        },
      }
    },
    btnBack () {
      const setting = this.getNavSetting
      const icons = setting && setting.icons && setting.icons.back
      return {
        src: icons && icons.image,
        style: {
          width: `${icons && icons.size}px`
        }
      }
    },
    btnStyle () {
      const setting = this.getPageSetting
      return setting && {
        color: setting.backgroundColor,
        backgroundColor: setting.fontColor
      }
    },
    itemDisplay () {
      const setting = this.getMyCollectionSetting
      return setting && setting.display
    },
    getItemProperties () {
      return this.$store.getters['collection/getItemProperties']
    }
  },
  mounted () {
    const searchCollection = this.$refs.searchCollection
    if (searchCollection) {
      searchCollection.focus()
    }
  },
  data () {
    return {
      keyword: '',
      resultKeyword: '',
      list: []
    }
  },
  methods: {
    goBack () {
      this.$emit('close')
    },
    searchItemProperties () {
      const keyword = this.keyword
      const itemProperty = this.getItemProperties
      if (!itemProperty || typeof itemProperty !== 'object') return []

      const normalize = (value) => {
        return regExp.replaceAllEmpty(value)
      }

      const normalizedKeyword = normalize(keyword)
      if (!normalizedKeyword) return []

      const includesKeyword = (langObj) => {
        if (!langObj || typeof langObj !== 'object') return false

        return Object.values(langObj).some(text => {
          return normalize(text).includes(normalizedKeyword)
        })
      }

      this.resultKeyword = this.keyword

      this.list = Object.values(itemProperty).filter(item => {
        if (!item || typeof item !== 'object') return false
        if (!(item.categoryIds && item.categoryIds.length > 0)) return false

        const nameMatched = includesKeyword(item.collectionItemName)
        const descTopMatched = includesKeyword(item.attribute && item.attribute.descTop)
        const descBottomMatched = includesKeyword(item.attribute && item.attribute.descBottom)

        return nameMatched || descTopMatched || descBottomMatched
      })
    },
    getCategoryNames (categoryId) {
      if (!categoryId) return []

      const result = []
      let currentId = categoryId
      let depth = 0

      const getCategoryById = this.$store.getters['collection/getCategoryById']
      const getParentCategoryId = this.$store.getters['collection/getParentCategoryId']

      while (currentId && currentId !== 'main' && depth < 3) {
        const category = getCategoryById(currentId)
        if (!category) break

        result.push((category.categoryLabel && category.categoryLabel[this.lang]) || '')

        currentId = getParentCategoryId(currentId)
        depth += 1
      }

      return result.reverse().filter(Boolean)
    },
    getCategoryName (categoryId) {
      return this.getCategoryNames(categoryId).join(' | ')
    },
    goCategory (categoryId) {
      const getCategoryById = this.$store.getters['collection/getCategoryById'](categoryId)
      const categoryName = getCategoryById && getCategoryById.categoryLabel[this.lang]
      if (confirm(`${categoryName} 페이지로 이동하시겠습니까?`)) {
        this.$router.push({
          name: 'collectionPage',
          params: {
            ...this.$route.params,
            categoryId: categoryId
          }
        })
        this.$emit('close')
      }
    },
    isIncludes (el) {
      return this.itemDisplay && this.itemDisplay.includes(el)
    },
    getItemThumb (item) {
      return item && item.attribute && item.attribute.imageList && item.attribute.imageList[0]
    },
    async deleteItem (collectionItemId) {
      // const data = {
      //   pageId: this.pageId,
      //   collectionCategory: this.categoryId,
      //   orderItemId: collectionItemId
      // }
      // this.$store.commit('loading', true)
      // const res = await this.$store.dispatch('collection/removeMyCollectionItem', data)
      // if (res && res.status === 200) {
      //   this.$store.commit('collection/setToastMessage', '내 콜렉션에서 삭제되었습니다.')
      //   this.getMyCollectionItems()
      // } else {
      //   alert(res)
      // }
      // this.$store.commit('loading', false)
    },
    setDetail (item) {
      if (item.attribute.detailActive) {
        const detailType = item.attribute.detailType
        if (detailType === 'embed') {
          this.$store.commit('collection/setDetailVideo', item.collectionItemId)
        } else {
          this.$store.commit('collection/setDetailGallery', item.collectionItemId)
        }
      }
    },
  }
}
</script>